import Vue from 'vue'
import Vuex from 'vuex'

import Constant from '@/const'

const jwt = require('jsonwebtoken')

Vue.use(Vuex)

// Masa berlaku token menurut jam perangkat sendiri.
//
// Sengaja tidak dibandingkan langsung dengan `exp` JWT: `exp` adalah waktu server,
// sedangkan pembandingnya jam perangkat. Perangkat yang jamnya maju lebih dari umur
// token membuat token yang baru terbit langsung dianggap kedaluwarsa — login berhasil,
// tapi guard router melempar balik ke halaman login tanpa pesan apa pun. Yang disimpan
// karena itu `sekarang + (exp - iat)`, sehingga kedua ujung perbandingan memakai jam
// yang sama dan selisih jam perangkat terhadap server tidak berpengaruh.
const TOKEN_EXPIRES_AT_KEY = 'tokenExpiresAt'

const hitungMasaBerlaku = token => {
  try {
    const { exp, iat } = jwt.decode(token)
    const umur = exp - iat
    // Token tanpa `iat`, atau yang umurnya tidak masuk akal, tidak bisa diukur dengan
    // cara ini; pembacaannya jatuh ke `exp` seperti sebelumnya.
    if (!(umur > 0)) return null

    return Date.now() + umur * 1000
  } catch {
    return null
  }
}

export default new Vuex.Store({
  state: {
    isMini: true,
    isConnected: false,
    socketMessage: '',
    token: localStorage.getItem('token'),
    tokenExpiresAt: Number(localStorage.getItem(TOKEN_EXPIRES_AT_KEY)) || null,
    apiVersion: '0.0.0',
    isAddSubscriptionRestrictionEnabled: Constant.subscriptionRestriction.fallback === true
  },
  getters: {
    isMini: state => state.isMini,
    apiVersion: state => state.apiVersion,
    isAddSubscriptionRestrictionEnabled: state => state.isAddSubscriptionRestrictionEnabled,
    isSocketConnect: state => state.isConnected,
    token: state => state.token,
    // true juga saat tokennya tidak ada atau tidak terbaca, supaya pemanggilnya tidak
    // perlu memeriksa keduanya terpisah.
    isTokenExpired: state => {
      if (state.tokenExpiresAt) return Date.now() >= state.tokenExpiresAt

      // Token yang tersimpan sebelum perubahan ini belum punya catatan masa berlaku
      // lokal. Dibaca dengan cara lama supaya sesi yang sedang berjalan tidak putus
      // begitu versi ini dipasang.
      try {
        const { exp } = jwt.decode(state.token)
        return typeof exp !== 'undefined' && exp * 1000 <= Date.now()
      } catch {
        return true
      }
    },
    userLoggedIn: state => {
      if (state.token !== null) {
        return jwt.decode(state.token).tokenStaff
      }
      return null
    },
    isJwtVerified: (state, getters) => !!state.token && !getters.isTokenExpired
  },
  mutations: {
    sidenavmini(state, isMini) {
      state.isMini = isMini
    },
    apiVersion(state, version) {
      state.apiVersion = version
    },
    addSubscriptionRestriction(state, isEnabled) {
      state.isAddSubscriptionRestrictionEnabled = isEnabled
    },
    saveToken(state, token) {
      localStorage.setItem('token', token)
      state.token = token

      const expiresAt = hitungMasaBerlaku(token)
      state.tokenExpiresAt = expiresAt
      if (expiresAt) localStorage.setItem(TOKEN_EXPIRES_AT_KEY, expiresAt)
      else localStorage.removeItem(TOKEN_EXPIRES_AT_KEY)
    },
    // Tokennya ikut dibuang dari localStorage di sini supaya catatan masa berlakunya
    // tidak pernah tertinggal sendirian; pemanggil yang sudah menghapusnya lebih dulu
    // tidak terpengaruh.
    removeToken(state) {
      state.token = null
      state.tokenExpiresAt = null
      localStorage.removeItem('token')
      localStorage.removeItem(TOKEN_EXPIRES_AT_KEY)
    },
    SOCKET_CONNECT(state) {
      state.isConnected = true
      // console.log('Connected : ' + state)
    },
    SOCKET_DISCONNECT(state) {
      state.isConnected = false
      // console.log('Disconnected : ' + state)
    }
  },
  actions: {},
  modules: {}
})
